import {
  InputBaseComponentProps,
  TextField,
  TextFieldProps,
} from '@mui/material';
import React, { RefObject } from 'react';
import { IMaskInput } from 'react-imask';

type EinMaskProps = InputBaseComponentProps & {
  onChange: (event: { target: { name: string; value: string } }) => void;
  unmask?: boolean;
  name: string;
};

const EinMask = React.forwardRef<HTMLElement, EinMaskProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={[{ mask: '00-0000000' }]}
      inputRef={ref as RefObject<HTMLInputElement>}
      onAccept={(value: string) => {
        onChange({ target: { name: props.name, value } });
      }}
      overwrite
    />
  );
});

type EinFieldProps = Omit<TextFieldProps, 'inputComponent' | 'InputProps'> &
  EinMaskProps;

export const EinField: React.FC<EinFieldProps> = ({ unmask, ...props }) => {
  return (
    <TextField
      {...props}
      InputProps={{
        inputComponent: EinMask,
        inputProps: { unmask },
      }}
    />
  );
};

export default EinField;
